import * as React from "react";
import { cn } from "@/core/utils/utils";

export type KbdProps = React.HTMLAttributes<HTMLElement>;

const Kbd = React.forwardRef<HTMLElement, KbdProps>(
  ({ className, ...props }, ref) => (
    <kbd
      ref={ref}
      className={cn(
        "pointer-events-none inline-flex h-5 min-w-5 select-none items-center justify-center rounded-sm border border-stroke-tertiary bg-surface-secondary px-1 font-sans text-sm font-medium text-secondary-text",
        "[[data-tone=dark]_&]:border-transparent [[data-tone=dark]_&]:bg-surface-primary/15 [[data-tone=dark]_&]:text-primary-inverse-text",
        className,
      )}
      {...props}
    />
  ),
);
Kbd.displayName = "Kbd";

const KbdGroup = React.forwardRef<
  HTMLSpanElement,
  React.HTMLAttributes<HTMLSpanElement>
>(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn("inline-flex items-center gap-1", className)}
    {...props}
  />
));
KbdGroup.displayName = "KbdGroup";

export { Kbd, KbdGroup };
